import React from 'react';
// import { ButtonCommon } from '../Button/ButtonCommon';
// import { Info } from '@phosphor-icons/react/dist/ssr';
import { Transaction } from 'models/Transaction';
import { formatPrice } from 'utils';
import dayjs from 'dayjs';
import { Tag } from 'antd';
import HorizontalScrollContainer from '../ScrollContainer/HorizontalScrollContainer';

interface TransactionCardProps {
  transaction: Transaction;
  onClick?: () => void;
}

const TransactionCard: React.FC<TransactionCardProps> = ({ transaction }) => {
  // Format month and day from the createdAt
  const month = dayjs(transaction.createdAt).format('M');
  const day = dayjs(transaction.createdAt).format('D');

  // Determine transaction type display information
  const getTransactionTypeInfo = () => {
    const typeMap = {
      //       export enum ETransType {
      //   Income = 'INCOME',
      //   Outcome = 'OUTCOME',
      //   Deposit = 'DEPOSIT',
      //   OS_EXTRA_FEE = 'OS_EXTRA_FEE',
      // }
      INCOME: {
        text: 'Thu tiền',
        color: 'text-[var(--sematicSuccessColor500)]',
        bgColor: 'bg-[var(--sematicSuccessColor500)]',
        borderColor: 'border-[var(--sematicSuccessColor500)]',
      },
      OUTCOME: {
        text: 'Chi tiền',
        color: 'text-[var(--sematicErrorColor500)]',
        bgColor: 'bg-[var(--sematicErrorColor500)]',
        borderColor: 'border-[var(--sematicErrorColor500)]',
      },
      DEPOSIT: {
        text: 'Đặt cọc',
        color: 'text-[var(--primaryColor500)]',
        bgColor: 'bg-[var(--primaryColor500)]',
        borderColor: 'border-[var(--primaryColor500)]',
      },
      OS_EXTRA_FEE: {
        text: 'Phụ phí',
        color: 'text-[var(--sematicErrorColor600)]',
        bgColor: 'bg-[var(--sematicErrorColor600)]',
        borderColor: 'border-[var(--sematicErrorColor600)]',
      },
    };

    return typeMap[transaction.type] || typeMap.INCOME;
  };

  const typeInfo = getTransactionTypeInfo();

  // Generate transaction code (simplified - you might have a different format)
  const transactionCode = `TR${transaction.id.slice(-6).toUpperCase()}`;

  return (
    <div className={`flex bg-white shadow-sm border-l-8 ${typeInfo.borderColor}`}>
      <HorizontalScrollContainer className='flex-1 w-0' contentClassName='h-20' showArrows={true}>
        <div className='flex h-20 pl-6 py-3 min-w-[800px]'>
          {/* Month and Day */}
          <div className='w-20 flex-shrink-0 flex flex-col justify-between'>
            <div className='text-black/60 text-sm font-medium'>Tháng {month}</div>
            <div className='text-black text-xl !leading-[20px] font-bold'>{day}</div>
          </div>

          {/* Transaction Code */}
          <div className='w-40 flex-shrink-0 flex flex-col justify-between'>
            <div className='text-black/60 text-sm'>Mã giao dịch</div>
            <div className='text-black text-xl !leading-[20px] font-bold'>{transactionCode}</div>
          </div>

          {/* Transaction Amount */}
          <div className='w-48 flex-shrink-0 px-3 flex flex-col justify-between'>
            <div className='text-black/60 text-sm'>Giá trị</div>
            <div className={`${typeInfo.color} text-sm font-bold`}>
              {/* {transaction.type === 'INCOME' ? '+' : '-'} */}
              {formatPrice(transaction.transactionAmount)} VND
            </div>
          </div>

          {/* Transaction Type */}
          {/* <div className='w-36 flex-shrink-0 px-3 flex flex-col justify-between'>
            <div className='text-black/60 text-sm'>Loại giao dịch</div>
            <Tag
              className={`${typeInfo.bgColor} text-white rounded-full text-sm border-0 px-4 py-1 max-w-fit text-center !m-0`}
            >
              {typeInfo.text}
            </Tag>
          </div> */}

          {/* Reference Type */}
          <div className='w-36 flex-shrink-0 px-3 flex flex-col justify-between'>
            <div className='text-black/60 text-sm'>Loại giao dịch</div>
            <Tag className='bg-black/5 text-black rounded-full border-0 px-4 py-1 max-w-fit'>
              {transaction.refTable === 'SaleOrders' ? 'Bán hàng' : 'Nhập hàng'}
            </Tag>
          </div>
          <div className='w-36 flex-shrink-0 px-3 flex flex-col justify-between'>
            <div className='text-black/60 text-sm'>Giao dịch</div>
            <Tag className={'bg-black/5 rounded-full border-0 px-4 py-1 max-w-fit font-semibold ' + typeInfo.color}>
              {typeInfo.text}
            </Tag>
          </div>

          {/* Transaction Method */}
          <div className='flex-1 min-w-[120px] pl-3 flex flex-col justify-between'>
            <div className='text-black/60 text-sm'>Phương thức</div>
            <div className='text-black text-sm font-medium'>
              {transaction.transactionMethod?.name || 'Chưa xác định'}
            </div>
          </div>
        </div>
      </HorizontalScrollContainer>

      {/* <div className='w-[140px] flex-shrink-0 h-20 flex items-center justify-center border-l bg-white'>
        <ButtonCommon color='text' size='sm' onClick={onClick} icon={<Info size={20} />}>
          Xem chi tiết
        </ButtonCommon>
      </div> */}
    </div>
  );
};

export default TransactionCard;
